import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa';
import { Discuss } from 'react-loader-spinner';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import crypto from 'crypto';

import DoctorCard from './feedback/DoctorCard';
import { showError } from '../../utils';
import { addFeedback, fetchFeedbackRatings } from '../../services';
import { logout } from '../../actions';
import Experience from './feedback/Experience';
import StyledTappable from '../common/StyledTappable';

import arrowBack from '../../images/arrow_back.svg';

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: white;
  padding-bottom: 30px;
`;

const HeadContainer = styled.div`
  flex: 1 1 10%;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0px 20px;
`;

const BodyContainer = styled.div`
  flex: 1 1 90%;
  width: 100%;
  display: flex;
  gap: 24px;
  align-items: center;
  /* justify-content: center; */
  flex-direction: column;
  overflow: auto;
`;

const HeadText = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
`;

const SkipContainer = styled.div`
  display: flex;
  background: #f0f3f6;
  width: 62px;
  height: 31px;
  padding: 8px 8px 8px 12px;
  gap: 4px;
  border-radius: 24px;
  opacity: 0px;
  align-items: center;
  cursor: pointer;
`;

const SkipText = styled.p`
  font-size: 12px;
  font-weight: 600;
  line-height: 14.52px;
  text-align: right;
  color: #858585;
`;

const SubmitBtn = styled.button`
  background: var(--primary-button);
  width: 80%;
  height: 48px;
  padding: 14px 0px 14px 0px;
  gap: 10px;
  border-radius: 12px;
  opacity: 0px;
  font-size: 14px;
  font-weight: 700;
  line-height: 19.6px;
  text-align: center;
  color: #ffffff;
  margin-top: 20px;
`;

const LoaderContainer = styled.div`
  flex: 1 1 90%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BackContainer = styled(StyledTappable)`
  padding-right: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Function to decrypt the cid
function decryptCid(encryptedCid) {
  const algorithm = 'aes-256-cbc';
  const [iv, encryptedText, key] = encryptedCid
    .split(':')
    .map((part) => Buffer.from(part, 'hex'));

  let decipher = crypto.createDecipheriv(algorithm, Buffer.from(key), iv);
  let decrypted = decipher.update(encryptedText);
  decrypted = Buffer.concat([decrypted, decipher.final()]);

  return decrypted.toString();
}

const FeedBackContainer = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const consulationChatContainer =
    history.location?.state?.consulationChatContainer;
  const { feedbacks } = useSelector((state) => state.feedback);
  const params = new URLSearchParams(location.search);
  const encryptedCid = params.get('cid');
  const consultationId = consulationChatContainer
    ? params.get('cid')
    : decryptCid(encryptedCid);
  const [feedbackStatus, setFeedbackStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  // const consultationId = params.get('cid');

  useEffect(() => {
    if (!consulationChatContainer) {
      dispatch(logout(history));
      history.push(`/consultations/feedback?cid=${encryptedCid}`);
    }
    getFeedbackRatings();
  }, []);

  const getFeedbackRatings = async () => {
    try {
      const data = await fetchFeedbackRatings({ consultationId });
      setFeedbackStatus(data);
      setTimeout(() => {
        setLoading(false);
      }, 800);
    } catch (err) {
      showError(err);
    }
  };

  const handleSubmitFeedback = async () => {
    try {
      await addFeedback({
        consultationId: consultationId,
        feedbacks: feedbacks,
      });
      getFeedbackRatings();
    } catch (err) {
      showError(err);
    }
  };

  return (
    <OuterContainer>
      <HeadContainer>
        {consulationChatContainer ? (
          <BackContainer onTap={() => history.goBack()}>
            <img src={arrowBack} alt="" />
          </BackContainer>
        ) : null}
        <HeadText>Feedback</HeadText>
        {/* <SkipContainer>
          <SkipText>Skip</SkipText>
          <FaTimes style={{color: '#858585', height: '10px', width: '10px'}}/>
        </SkipContainer> */}
      </HeadContainer>
      {loading && (
        <LoaderContainer>
          <Discuss
            visible={true}
            height="80"
            width="80"
            ariaLabel="discuss-loading"
            wrapperStyle={{}}
            wrapperClass="discuss-wrapper"
            backgroundColor="var(--primary-button)"
            colors={['var(--primary-button)', 'var(--primary-button)']}
          />
        </LoaderContainer>
      )}
      {!loading && (
        <BodyContainer>
          <DoctorCard
            feedbackStatus={feedbackStatus}
            consulationChatContainer={consulationChatContainer|| false}
          />
          <Experience feedbackStatus={feedbackStatus} />
        </BodyContainer>
      )}
      {!loading && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {(!feedbackStatus || !feedbackStatus.feedBackStatus) &&
            feedbacks.length > 1 && (
              <SubmitBtn onClick={handleSubmitFeedback}>Submit</SubmitBtn>
            )}
        </div>
      )}
    </OuterContainer>
  );
};

export default FeedBackContainer;
